import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import Icon from 'antd/lib/icon';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAllDataSetFilter } from 'src/actions/discoverRatesActions';
import { InquiryConfirmationModalStyles } from '../DiscoverRate/InquiryConfirmationModal.styles';
import { SearchFilters } from '../DiscoverRate/TypesInDiscoverRates/SearchFilters';
import moment from 'moment';
import RouteInfoWithFlag from '../DiscoverRate/RouteInfoWithFlag';

interface SendInquiryInConnectionsModalProps extends
  StylesProps<ReturnType<typeof InquiryConfirmationModalStyles>> {
  isVisible: boolean;
  searchFilters: SearchFilters;
  onSuccess: () => void;
  inquiryData: any;
}

const SendInquiryInConnectionsModal = (props: SendInquiryInConnectionsModalProps):
  React.ReactElement => {

  const {
    isVisible,
    classes,
    searchFilters,
    onSuccess,
    inquiryData,
  } = props;

  const renderConfirmationTitle = () => {
    return (
      <div className={classes.confirmationTitle}>
        <Icon type="check-circle" theme="filled" style={{ color: '#52C41A', fontSize: '20px' }} />
        &nbsp; Inquiry <span style={{ fontWeight: 600 }}>
          &nbsp; {inquiryData?.referenceNumber}</span>
          &nbsp;has been created successfully.
      </div>
    );
  };

  const renderLine = (): React.ReactElement => {
    return <div className={classes.line}/>;
  };

  const renderDot = (styles): React.ReactElement => {
    return <div className={classes.dot} style={{...styles, height: '9px', width: '9px' }} />;
  };

  const renderOkayButton = () => {
    return (
      <div className={classes.okButton}>
        <Button className={classes.createNewButton} style={{ borderRadius: '4px' }}
          onClick={() => onSuccess()}>
          Okay
        </Button>
      </div>
    )
  }

  const renderDeadline = () => {
    return (
      <div>
        <Icon type="hourglass" />
        <span className={classes.deadline}>
          {`${moment(inquiryData.deadline)?.format('DD MMMM YYYY | HH:mm')} Hrs`}
        </span>
      </div>
    )
  }

  const renderConfirmationBody = () => {
    return (
      <React.Fragment>
        <RouteInfoWithFlag
          origin={searchFilters.pol}
          destination={searchFilters.pod}
          portStyle={true}
        />
        {renderDeadline()}
        {renderOkayButton()}
      </React.Fragment>
    );
  };

  return (
    <Modal
      visible={isVisible}
      footer={null}
      closable={false}
      zIndex={1200}
      style={{ padding: 12 }}
      title={renderConfirmationTitle()}
    >
      {renderConfirmationBody()}
    </Modal>
  );
};

const mapStateToProps = ({ discoverRatesReducer, inquiryShipperReducer }, ownProps) => ({
  searchFilters: discoverRatesReducer.searchFilters,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getAllDataSetFilter,
  }, dispatch);
};

export default connect(mapStateToProps,
  mapDispatchToProps)(withStyles(InquiryConfirmationModalStyles)(SendInquiryInConnectionsModal));
